import React from 'react';

export const Tags = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--tags';
  color = color || '#0076CC';

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M18.6651 19.6653L20.4337 17.8967C21.4377 16.8926 22.0017 15.5308 22.0017 14.1108C22.0017 12.6908 21.4377 11.329 20.4337 10.3249L15.3325 5.22363M6.44526 9.66761H6.43415M2.00171 7.44542V12.0801C2.00183 12.6693 2.236 13.2343 2.65269 13.6509L8.99591 19.9941C9.49798 20.4961 10.1789 20.7781 10.8889 20.7781C11.5989 20.7781 12.2798 20.4961 12.7818 19.9941L16.7722 16.0038C17.2742 15.5017 17.5562 14.8208 17.5562 14.1108C17.5562 13.4008 17.2742 12.7199 16.7722 12.2178L10.429 5.87462C10.0124 5.45792 9.44736 5.22376 8.85816 5.22363H4.2235C3.63424 5.22363 3.06912 5.45771 2.65246 5.87438C2.23579 6.29105 2.00171 6.85617 2.00171 7.44542Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Tags;
